"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _default = (0, _createReactClass.default)({
  renderTimePickerButtons: function renderTimePickerButtons() {
    return (0, _toConsumableArray2.default)(Array(4)).map(function (value, index) {
      return _react.default.createElement("div", {
        key: index,
        className: "p-y-1 p-right-1"
      }, _react.default.createElement(_UISelectableBox.default, {
        block: true,
        padded: false,
        selected: false,
        className: "time-picker-btn"
      }, _react.default.createElement("div", {
        className: "skeleton"
      })));
    });
  },
  renderInputs: function renderInputs() {
    return _react.default.createElement("div", {
      className: "time-list-container"
    }, _react.default.createElement("div", {
      className: "time-list"
    }, this.renderTimePickerButtons()));
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "time-picker time-picker-skeleton width-100"
    }, _react.default.createElement(_H.default, {
      className: "skeleton-text"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.timePicker.header"
    })), this.renderInputs());
  }
});

exports.default = _default;
module.exports = exports.default;